import { render, staticRenderFns } from "./RequestActive.vue?vue&type=template&id=3445d35e&scoped=true"
import script from "./RequestActive.vue?vue&type=script&lang=js"
export * from "./RequestActive.vue?vue&type=script&lang=js"
import style0 from "./RequestActive.vue?vue&type=style&index=0&id=3445d35e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445d35e",
  null
  
)

export default component.exports